module.exports = __webpack_public_path__ + "static/banner_f.0fe6352e.png";